import * as React from "react";
import { Button, ButtonGroup, Form } from "react-bootstrap";
import { snakeCase } from "change-case";
import { FilterInterface } from "../../store/Filter";
import style from "./style.module.css";
import { ConfigDialog } from "../ConfigDialog";
import { BsGearFill, BsSearch, BsX } from "react-icons/bs";
import { observer } from "mobx-react-lite";
import { getStore } from "../../store";
import { useEffect } from "react";

interface FilterElemProps {
  children?: React.ReactNode;
}

const FilterElem = (props: FilterElemProps) => (
  <Form.Group className={style.filterElem} {...props}>
    {props.children}
  </Form.Group>
);

export const Filter = observer(() => {
  const { app, list, config } = getStore();
  const { filter } = list;

  useEffect(() => {
    onClickSearch();
  }, []);

  const onClickSearch = () => {
    list.search(1);
  };

  const onClickClear = () => {
    list.clearFilter();
  };

  const onClickOpenConfig = () => {
    config.isOpened = true;
  };

  const onChangeText = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.currentTarget;
    list.filter[name as keyof FilterInterface] = value;
  };

  const onChangeCheckbox = (e: React.FormEvent<HTMLInputElement>) => {
    const { name, checked } = e.currentTarget;
    const index = filter.envs.indexOf(name);
    if (checked && index < 0) {
      filter.envs.push(name);
    } else if (!checked && index >= 0) {
      filter.envs.splice(index, 1);
    }
  };

  const actualAvailableEnvs = app.idScrambled
    ? filter.availableEnvs.filter((env) => env === "dd1")
    : filter.availableEnvs;
  const checkboxes = actualAvailableEnvs.map((env) => (
    <Form.Check
      type="checkbox"
      id={`env-${env}-check`}
      inline
      key={env}
      name={env}
      checked={filter.envs.includes(env)}
      onChange={onChangeCheckbox}
      label={env}
    />
  ));

  const textForm = (name: keyof FilterInterface, isInvalid: boolean) => (
    <Form.Control
      className={style.filterElemInput}
      type="text"
      name={name}
      value={filter[name]}
      placeholder={snakeCase(name)}
      onChange={onChangeText}
      isInvalid={isInvalid}
    />
  );
  return (
    <div className={`${style.filterForm} filter-widget`}>
      <Form>
        <FilterElem>{checkboxes}</FilterElem>
        <FilterElem>{textForm("eventId", false)}</FilterElem>
        {!app.idScrambled && (
          <FilterElem>
            {filter.hasNsaIdError() && (
              <Form.Text muted>{filter.nsaIdError}</Form.Text>
            )}
            {textForm("nsaId", filter.hasNsaIdError())}
          </FilterElem>
        )}
        {!app.idScrambled && (
          <FilterElem>{textForm("deviceId2", false)}</FilterElem>
        )}
        {!app.idScrambled && (
          <FilterElem>{textForm("serialNumber", false)}</FilterElem>
        )}
        <ButtonGroup>
          <Button
            variant="light"
            className={`${style.filterElemButton} search-button`}
            onClick={onClickSearch}
            disabled={filter.hasError()}
          >
            <BsSearch />
          </Button>
          <Button
            variant="light"
            className={`${style.filterElemButton} clear-button`}
            onClick={onClickClear}
          >
            <BsX />
          </Button>
          <Button
            variant="light"
            className={`${style.filterElemButton} cog-button`}
            onClick={onClickOpenConfig}
          >
            <BsGearFill />
          </Button>
        </ButtonGroup>
      </Form>
      <ConfigDialog />
    </div>
  );
});
